import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    afrikaans: string;
    azerbaijani: string;
    bashkir: string;
    belarusian: string;
    bulgarian: string;
    bengali: string;
    catalan: string;
    mandarinSimplified: string;
    mandarinTraditional: string;
    welsh: string;
    danish: string;
    german: string;
    englishAustralia: string;
    englishCanada: string;
    englishUnitedKingdom: string;
    englishIndia: string;
    englishNewZealand: string;
    englishUnitedStates: string;
    esperanto: string;
    spanish: string;
    estonian: string;
    basque: string;
    persian: string;
    finnish: string;
    french: string;
    irish: string;
    galician: string;
    hindi: string;
    croatian: string;
    hungarian: string;
    interlingua: string;
    italian: string;
    japanese: string;
    korean: string;
    lithuanian: string;
    latvian: string;
    macedonian: string;
    mongolian: string;
    malay: string;
    maltese: string;
    marathi: string;
    norwegian: string;
    dutch: string;
    polish: string;
    portuguese: string;
    romanian: string;
    russian: string;
    slovak: string;
    slovenian: string;
    serbian: string;
    swedish: string;
    swahili: string;
    tamil: string;
    thai: string;
    uyghur: string;
    urdu: string;
    cantonese: string;
    arabic: string;
    auto: string;
    czech: string;
    greek: string;
    hebrew: string;
    indonesian: string;
    turkish: string;
    ukrainian: string;
    vietnamese: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            afrikaans: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.afrikaans?c=1utu46p9mpz8j", defaultMessage: "Afrikaans" }));
                },
                enumerable: true,
                configurable: true
            },
            azerbaijani: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.azerbaijani?c=1jvghbe5hadx1", defaultMessage: "Azerbaijani" }));
                },
                enumerable: true,
                configurable: true
            },
            bashkir: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.bashkir?c=21jjhlyo7hye6", defaultMessage: "Bashkir" }));
                },
                enumerable: true,
                configurable: true
            },
            belarusian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.belarusian?c=32sx0lm2y1d2s", defaultMessage: "Belarusian" }));
                },
                enumerable: true,
                configurable: true
            },
            bulgarian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.bulgarian?c=2ectz1b69bh3f", defaultMessage: "Bulgarian" }));
                },
                enumerable: true,
                configurable: true
            },
            bengali: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.bengali?c=1zw1ca4uxajxy", defaultMessage: "Bengali" }));
                },
                enumerable: true,
                configurable: true
            },
            catalan: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.catalan?c=2hgb8n7ztw0ef", defaultMessage: "Catalan" }));
                },
                enumerable: true,
                configurable: true
            },
            mandarinSimplified: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.mandarinSimplified?c=1qdvxhst4u072", defaultMessage: "Mandarin (Simplified)" }));
                },
                enumerable: true,
                configurable: true
            },
            mandarinTraditional: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.mandarinTraditional?c=1a5bix1796dsn", defaultMessage: "Mandarin (Traditional)" }));
                },
                enumerable: true,
                configurable: true
            },
            welsh: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.welsh?c=aatdquvtvi61", defaultMessage: "Welsh" }));
                },
                enumerable: true,
                configurable: true
            },
            danish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.danish?c=iy4bcp2nbtem", defaultMessage: "Danish" }));
                },
                enumerable: true,
                configurable: true
            },
            german: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.german?c=3vtfd4mh6r411", defaultMessage: "German" }));
                },
                enumerable: true,
                configurable: true
            },
            englishAustralia: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.englishAustralia?c=8dsa1pl69ylr", defaultMessage: "English (AU)" }));
                },
                enumerable: true,
                configurable: true
            },
            englishCanada: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.englishCanada?c=3i9rd9qvrdu4j", defaultMessage: "English (CA)" }));
                },
                enumerable: true,
                configurable: true
            },
            englishUnitedKingdom: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.englishUnitedKingdom?c=xylpu7wrtkju", defaultMessage: "English (UK)" }));
                },
                enumerable: true,
                configurable: true
            },
            englishIndia: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.englishIndia?c=ox0zsar8mmsu", defaultMessage: "English (I)" }));
                },
                enumerable: true,
                configurable: true
            },
            englishNewZealand: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.englishNewZealand?c=3b8vv92a4eaan", defaultMessage: "English (NZ)" }));
                },
                enumerable: true,
                configurable: true
            },
            englishUnitedStates: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.englishUnitedStates?c=gvapgrqx4an0", defaultMessage: "English (US)" }));
                },
                enumerable: true,
                configurable: true
            },
            esperanto: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.esperanto?c=67545ew6rz7a", defaultMessage: "Esperanto" }));
                },
                enumerable: true,
                configurable: true
            },
            spanish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.spanish?c=235fjnyhvlu3i", defaultMessage: "Spanish" }));
                },
                enumerable: true,
                configurable: true
            },
            estonian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.estonian?c=2yxcez9sxx1pe", defaultMessage: "Estonian" }));
                },
                enumerable: true,
                configurable: true
            },
            basque: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.basque?c=ja8eamn53tbg", defaultMessage: "Basque" }));
                },
                enumerable: true,
                configurable: true
            },
            persian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.persian?c=rk5d1jascl1z", defaultMessage: "Persian" }));
                },
                enumerable: true,
                configurable: true
            },
            finnish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.finnish?c=153bu1lvvaya0", defaultMessage: "Finnish" }));
                },
                enumerable: true,
                configurable: true
            },
            french: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.french?c=2kcyljt6fkyp2", defaultMessage: "French" }));
                },
                enumerable: true,
                configurable: true
            },
            irish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.irish?c=5056ih5hxhtz", defaultMessage: "Irish" }));
                },
                enumerable: true,
                configurable: true
            },
            galician: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.galician?c=3hlh8xs6qj5it", defaultMessage: "Galician" }));
                },
                enumerable: true,
                configurable: true
            },
            hindi: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.hindi?c=2muyua61rbvzb", defaultMessage: "Hindi" }));
                },
                enumerable: true,
                configurable: true
            },
            croatian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.croatian?c=3meiw2fhuq817", defaultMessage: "Croatian" }));
                },
                enumerable: true,
                configurable: true
            },
            hungarian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.hungarian?c=1azaq33x6poj5", defaultMessage: "Hungarian" }));
                },
                enumerable: true,
                configurable: true
            },
            interlingua: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.interlingua?c=5tohu44j5nx4", defaultMessage: "Interlingua" }));
                },
                enumerable: true,
                configurable: true
            },
            italian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.italian?c=1todwvohn7vhg", defaultMessage: "Italian" }));
                },
                enumerable: true,
                configurable: true
            },
            japanese: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.japanese?c=1wnfakaco47kj", defaultMessage: "Japanese" }));
                },
                enumerable: true,
                configurable: true
            },
            korean: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.korean?c=2af9r49fofklk", defaultMessage: "Korean" }));
                },
                enumerable: true,
                configurable: true
            },
            lithuanian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.lithuanian?c=1ufw1qk99v7sy", defaultMessage: "Lithuanian" }));
                },
                enumerable: true,
                configurable: true
            },
            latvian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.latvian?c=3984ta2b6y1x", defaultMessage: "Latvian" }));
                },
                enumerable: true,
                configurable: true
            },
            macedonian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.macedonian?c=3343gdogjiajl", defaultMessage: "Macedonian" }));
                },
                enumerable: true,
                configurable: true
            },
            mongolian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.mongolian?c=2p5unyndg1m1l", defaultMessage: "Mongolian" }));
                },
                enumerable: true,
                configurable: true
            },
            malay: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.malay?c=1oglari0iyj86", defaultMessage: "Malay" }));
                },
                enumerable: true,
                configurable: true
            },
            maltese: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.maltese?c=3dp6rc7okehzm", defaultMessage: "Maltese" }));
                },
                enumerable: true,
                configurable: true
            },
            marathi: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.marathi?c=1gsx5f7u7nxus", defaultMessage: "Marathi" }));
                },
                enumerable: true,
                configurable: true
            },
            norwegian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.norwegian?c=114g0pvxhvtu9", defaultMessage: "Norwegian" }));
                },
                enumerable: true,
                configurable: true
            },
            dutch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.dutch?c=klpcsy0sc2ul", defaultMessage: "Dutch" }));
                },
                enumerable: true,
                configurable: true
            },
            polish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.polish?c=r1nliz12mfnn", defaultMessage: "Polish" }));
                },
                enumerable: true,
                configurable: true
            },
            portuguese: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.portuguese?c=1yvfzh5m5bx0h", defaultMessage: "Portuguese" }));
                },
                enumerable: true,
                configurable: true
            },
            romanian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.romanian?c=1x2gaowtmnk4w", defaultMessage: "Romanian" }));
                },
                enumerable: true,
                configurable: true
            },
            russian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.russian?c=v2nnh41air2x", defaultMessage: "Russian" }));
                },
                enumerable: true,
                configurable: true
            },
            slovak: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.slovak?c=3m55u6xrl0lf2", defaultMessage: "Slovak" }));
                },
                enumerable: true,
                configurable: true
            },
            slovenian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.slovenian?c=3i6gmjt7sh20a", defaultMessage: "Slovenian" }));
                },
                enumerable: true,
                configurable: true
            },
            serbian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.serbian?c=2ho5i0443lnjd", defaultMessage: "Serbian" }));
                },
                enumerable: true,
                configurable: true
            },
            swedish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.swedish?c=3dagn8ourfez9", defaultMessage: "Swedish" }));
                },
                enumerable: true,
                configurable: true
            },
            swahili: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.swahili?c=1lzrmdylps9z1", defaultMessage: "Swahili" }));
                },
                enumerable: true,
                configurable: true
            },
            tamil: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.tamil?c=3hpcq6vxd0skm", defaultMessage: "Tamil" }));
                },
                enumerable: true,
                configurable: true
            },
            thai: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.thai?c=3l4tj99xi2ko7", defaultMessage: "Thai" }));
                },
                enumerable: true,
                configurable: true
            },
            uyghur: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.uyghur?c=16nh57691qbyk", defaultMessage: "Uyghur" }));
                },
                enumerable: true,
                configurable: true
            },
            urdu: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.urdu?c=2bpp411rf53vx", defaultMessage: "Urdu" }));
                },
                enumerable: true,
                configurable: true
            },
            cantonese: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.cantonese?c=2k8gac6ssoba5", defaultMessage: "Cantonese" }));
                },
                enumerable: true,
                configurable: true
            },
            arabic: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.arabic?c=1qw7zkgyp5i0z", defaultMessage: "Arabic" }));
                },
                enumerable: true,
                configurable: true
            },
            auto: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.auto?c=1j0atc9g0cl8w", defaultMessage: "Auto" }));
                },
                enumerable: true,
                configurable: true
            },
            czech: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.czech?c=27f29hxmm0ztq", defaultMessage: "Czech" }));
                },
                enumerable: true,
                configurable: true
            },
            greek: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.greek?c=2u5fcdfjm5swn", defaultMessage: "Greek" }));
                },
                enumerable: true,
                configurable: true
            },
            hebrew: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.hebrew?c=1x8u9lwrez1hf", defaultMessage: "Hebrew" }));
                },
                enumerable: true,
                configurable: true
            },
            indonesian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.indonesian?c=28dtjf80l9y1q", defaultMessage: "Indonesian" }));
                },
                enumerable: true,
                configurable: true
            },
            turkish: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.turkish?c=27kh9gdswa8vn", defaultMessage: "Turkish" }));
                },
                enumerable: true,
                configurable: true
            },
            ukrainian: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.ukrainian?c=3bq4x3eywmkla", defaultMessage: "Ukrainian" }));
                },
                enumerable: true,
                configurable: true
            },
            vietnamese: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "consts.vietnamese?c=1puyh4faugzm6", defaultMessage: "Vietnamese" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
